module.exports = __webpack_public_path__ + "static/media/terms-of-use.f03aa9ca.md";